// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"1d3da308","43":"2072b065","442":"afcb011e"}[chunkId] + ".chunk.js";
};